// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleServiceAccountManager = {
  id: "service-account-manager",
  mrn: "//iam.api.mondoo.app/roles/service-account-manager",
  title: "Service Account Manager",
  allowedActions,
} as const;

export type RoleServiceAccountManager = typeof roleServiceAccountManager;
